import FrontdeskPage from '@/features/tickets/pages/FrontdeskPage.vue'
import MyTicketsPage from '@/features/tickets/pages/MyTicketsPage.vue'

export default [
  {
    path: '/event/:eventId/front-desk',
    name: 'EventFrontDesk',
    component: FrontdeskPage,
  },
  {
    path: '/events/:eventId/my-tickets',
    name: 'EventMyTickets',
    component: MyTicketsPage,
  },
]
